import { useCallback, useMemo } from 'react'

import { separateLobbyForIOS } from '../../services/utils'
import { config } from '../../components/Init/Init'
import { getPlayerStatusFromStatus } from '../../services/helpers/playerHelper'
import { useCasinoStore, usePlayerStore } from '../../services/store'

export const useGetLobbySlug = () => {
  const playerStore = usePlayerStore()
  const playerStatus = playerStore.use.status()
  const playerPreferredLobby = playerStore.use.preferredLobby()

  const casinoStore = useCasinoStore()
  const casinoSweepstakesOrigin = casinoStore.use.casinoSweepstakesOrigin()

  const getLobbySlug = useCallback(() => {
    let lobbySlug

    if (separateLobbyForIOS(casinoSweepstakesOrigin)) {
      lobbySlug = config.iOSWebviewLobbySlug
    } else if (playerPreferredLobby) {
      lobbySlug = playerPreferredLobby
    } else if (getPlayerStatusFromStatus(playerStatus) === 'logged-out') {
      lobbySlug = config.loggedOutLobbySlug
    } else {
      lobbySlug = config.genericLobbySlug
    }

    return lobbySlug
  }, [casinoSweepstakesOrigin, playerStatus, playerPreferredLobby])

  const lobbySlug = useMemo(() => {
    return getLobbySlug()
  }, [casinoSweepstakesOrigin, playerStatus, playerPreferredLobby])

  return { lobbySlug, getLobbySlug }
}
